<div>
  <div class="rounded-xl h-60 w-full border bg-white flex items-center justify-center flex-col p-5 px-10 mt-4">
    <div class="grid place-content-center place-items-center">
      <div class="payment-success-animation flex items-center">
        <ng-lottie width="142px" height="142px" [options]="questionContentAnimationOptions"></ng-lottie>
      </div>
      <p class="text-base font-semibold m-0">One moment while we search for existing connections</p>
    </div>
  </div>
</div>
